import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Send, FileText, Inbox } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const TABS = [
    { key: "campaigns", to: "/app/engage/campaigns", icon: Send },
    { key: "templates", to: "/app/engage/templates", icon: FileText },
    { key: "inbox", to: "/app/engage/inbox", icon: Inbox },
];

export default function EngageLayout() {
    const { t } = useI18n();
    const location = useLocation();
    const isWizardOrDetail = /^\/app\/engage\/campaigns\/[^/]+/.test(location.pathname) ||
        location.pathname === "/app/engage/campaigns/new";
    const showTabs = !isWizardOrDetail;
    return (
        <div className="flex flex-col min-h-[calc(100vh-64px)]">
            {showTabs && (
                <div className="border-b border-white/8 bg-brand-void/40 backdrop-blur-sm sticky top-16 z-20">
                    <div className="px-6 lg:px-10 flex items-center gap-1 overflow-x-auto no-scrollbar">
                        {TABS.map((tab) => (
                            <NavLink
                                key={tab.key}
                                to={tab.to}
                                data-testid={`engage-tab-${tab.key}`}
                                className={({ isActive }) =>
                                    `relative inline-flex items-center gap-2 px-4 py-3 text-sm transition ${
                                        isActive ? "text-white" : "text-zinc-400 hover:text-white"
                                    }`
                                }
                            >
                                {({ isActive }) => (
                                    <>
                                        <tab.icon size={15} />
                                        <span>{t.engage.tabs[tab.key]}</span>
                                        {isActive && (
                                            <span className="absolute left-3 right-3 -bottom-px h-0.5 bg-gradient-to-r from-brand-indigo to-brand-cyan rounded-full" />
                                        )}
                                    </>
                                )}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
            <Outlet />
        </div>
    );
}
